/**
 * Fade-Bottom / Purple-Violet-Red.
 */ var PurpleVioletRed = [
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '1068',
        rotate: 130,
        blur: 19.3,
        x: '186',
        y: '-795'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '1068',
        rotate: 130,
        blur: 19.3,
        x: '-585',
        y: '-534'
    },
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '967',
        rotate: 130,
        blur: 21.3,
        x: '995',
        y: '-540'
    }
];

export { PurpleVioletRed as default };
//# sourceMappingURL=purple-violet-red.es.js.map
